import { render, staticRenderFns } from "./GamePeriodData.vue?vue&type=template&id=67ab9040&scoped=true&"
import script from "./GamePeriodData.vue?vue&type=script&lang=js&"
export * from "./GamePeriodData.vue?vue&type=script&lang=js&"
import style0 from "./GamePeriodData.vue?vue&type=style&index=0&id=67ab9040&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ab9040",
  null
  
)

export default component.exports